import { render, staticRenderFns } from "./share-card-sketch.vue?vue&type=template&id=79ef27a2&scoped=true&"
import script from "./share-card-sketch.vue?vue&type=script&lang=js&"
export * from "./share-card-sketch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ef27a2",
  null
  
)

export default component.exports